export default "__VITE_ASSET__CN97zs7j__"